import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { User } from '../../core/models/user.model';
import { RoleService } from '../../core/services/role.service';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../../core/services/user.service';
import { UpdateAreaService } from '../../core/services/update-area.service';

@Component({
  selector: 'app-user-management-create',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, HttpClientModule, CommonModule],
  templateUrl: './user-management-create.component.html',
  styleUrl: './user-management-create.component.scss'
})
export class UserManagementCreateComponent implements OnInit {
  editMode: boolean = false
  userId: number | null = null
  errorMessage: string = ''
  userForm!: FormGroup
  areas: any = []
  states: any = [ { id: 1, name: 'Activo' }, { id: 0, name: 'Inactivo' } ]

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private userService: UserService,
    private updateAreaService: UpdateAreaService) { }

  async ngOnInit(): Promise<void> {
    


    this.route.params.subscribe(params => {
      console.log('Parámetros de ruta recibidos:', params);
      this.userId = +params['userId']
      const edit: any = params['edit']
      console.log('la que llega, edit', edit)
      this.editMode = edit == 'true' ? true : false
      if (this.userId) {
        //this.editMode = true
        this.createForm()
        this.getAreas()
        this.getUserAndPatch(this.userId)
      }
      

    });

  }

  private async getAreas() {
    try {
      const res = await firstValueFrom(this.updateAreaService.getAll())
      this.areas = res
    } catch {
      console.error('fallo en obtener areas')
      this.areas = []
    }
  }

  private createForm() {
    this.userForm = this.fb.group({
      fullName: [{ value: '', disabled: !this.editMode }, Validators.required],
      email: [{ value: '', disabled: !this.editMode }, [Validators.required, Validators.email]],
      area: [{ value: '', disabled: !this.editMode }, Validators.required], 
      state: [{ value: '', disabled: !this.editMode }, Validators.required],

    });
  }

  private async getUserAndPatch(userId: number) {
    try {
      const userInfo = await firstValueFrom(this.userService.getById(userId))
      this.parchValues(userInfo)
    } catch(err) {
      console.error(err)
    }
  }

  private parchValues(user: User) {
    this.userForm.patchValue({
      fullName: user.fullName,
      email: user.email,
      area: user.area?.id,
      state: user.disabled ? 0 : 1
    })
  }


  async onSubmit() {
    if(this.userForm.invalid) return
    const payload = this.buildUpdateUserPayload(this.userForm.value)
    try{
      const response =  await firstValueFrom(this.userService.update(this.userId!, payload))
      this.router.navigate(['/user-management'])
    }catch(err){
      console.error(err)
    }
  }

  buildUpdateUserPayload(formValue: any): any {
    return {
      id        : this.userId,
      fullName  : formValue.fullName,
      email     : formValue.email,
      disabled  : formValue.state == 0 ? true : false,
      areaId    : formValue.area
    }
  }

}
